module.exports = __webpack_public_path__ + "media/images/ANTIGEN-Banner-20c01668939e55fbcf1c6acb88a54938.png";